import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import "./assets/css/animate.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/fontawesome.min.css";

import "./assets/css/nice-select.css";
import "./assets/css/slick.css";
import "./assets/css/style.css";
import About from "./views/main/About";
import CarControl from "./views/main/CarControl";
import Cars from "./views/main/Cars";
import Contact from "./views/main/Contact";
import Error from "./views/main/Error";
import Home from "./views/main/Home";
import Login from "./views/main/Login";
import Profile from "./views/main/Profile";
import Registration from "./views/main/Registration";
import Shop from "./views/main/Shop";
import ShopDetails from "./views/main/ShopDetails";
import Tournament from "./views/main/Tournaments";
import TournamentSingle from "./views/main/TournamentSingle";
import Admin from "./views/admin/Admin";
import EditCar from "./views/admin/EditCar";
import AddCar from "./views/admin/AddCar";

export default function App() {
  return (
    <Router>
      <Switch>
        <Route path="/car/:id" component={CarControl} />
        <Route path="/cars" component={Cars} />
        <Route path="/contact" component={Contact} />
        <Route path="/error" component={Error} />
        <Route path="/login" component={Login} />
        <Route path="/shop" component={Shop} />
        <Route path="/shop-details" component={ShopDetails} />
        <Route path="/profile" component={Profile} />
        <Route path="/editCar/:id" component={EditCar} />
        <Route path="/admin" component={Admin} />
        <Route path="/addCar" component={AddCar} />
        <Route path="/registration" component={Registration} />
        <Route path="/tournaments" component={Tournament} />
        <Route path="/tournamanet-single" component={TournamentSingle} />
        <Route path="/about" component={About} />
        <Route path="/" component={Home} />
      </Switch>
    </Router>
  );
}